import Spinner from '~/components/svg/Spinner';
import { cn } from '~/utils/';
import { usePopup } from '~/helpers/store';
import { useEffect } from 'react';

export default function ProcessLoading({ navVisible, conversationId }) {
    const pState = usePopup((state) => state);
    
    useEffect(() => {
        if (pState.showPricingPopup) {
            pState.setShowProcessLoading(false);
        }
    }, [pState.showPricingPopup]);
    
    if (pState.showPricingPopup) {
        return null;
    }
    
    return (
        <div style={{
            position: 'fixed',
            top: '0',
            bottom: '0',
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            zIndex: '100',
            background: '#ffffffa6',
        }} className={cn( 'process-loading', navVisible && conversationId === 'new' ? 'nav-visible' : '' )}>
            <Spinner className="m-auto" width='2.5em' height='2.5em' /> 
        </div>
    );
}